export default __webpack_public_path__ + "static/media/angle-left.4d0d468d.svg";